import React from 'react';

export const TrustPilotBox = () => {
  // Create a reference to the <div> element which will represent the TrustBox
  const ref = React.useRef(null);
  React.useEffect(() => {
    // If window.Trustpilot is available it means that we need to load the TrustBox from our ref.
    // If it's not, it means the script you pasted into <head /> isn't loaded  just yet.
    // When it is, it will automatically load the TrustBox.
    try {
      if ((window as any).Trustpilot && (window as any)?.Trustpilot?.loadFromElement && ref?.current) {
        (window as any).Trustpilot.loadFromElement(ref.current, true);
      }
    } catch (error) {
      console.error('An error occurred:', error);
    }
  }, []);

  return null;

  // return (
  //   <div className="m-auto">
  //     <div
  //       ref={ref} // We need a reference to this element to load the TrustBox in the effect.
  //       className="trustpilot-widget flex m-auto  justify-center my-4" // Renamed this to className.
  //       // [ long list of data attributes...]
  //       data-locale="fr-FR"
  //       data-template-id="56278e9abfbbba0bdcd568bc"
  //       data-businessunit-id="656cf1b6c1a001107bf4612a"
  //     >
  //       <a href="https://www.trustpilot.com/review/example.com" target="_blank" rel="noopener">
  //         Trustpilot
  //       </a>
  //     </div>
  //   </div>
  // );
};
